export const PRODUCT_PRICES_SORT_BY = [
  'buyer_name',
  'created_on',
  'end_date',
  'gross_price',
  'modified_on',
  'product_name',
  'seller_assigned_id',
  'seller_name',
  'start_date',
] as const;
